import * as api from "@/api/portalPosts.api"

export const fetchPortalPosts = async ({ commit }) => {
  commit("setPosts", await api.getAll())
}

export const createPortalPost = async (vuex, data) => {
  await api.create(data)
}

export const getPortalPost = async ({ commit }, id) => {
  commit("setPost", await api.get(id))
}

export const updatePortalPost = async (vuex, { postKey, ...data }) => {
  await api.update(postKey, data)
}

export const removePortalPost = async (vuex, id) => {
  await api.remove(id)
}

export const resetPortalPost = async (context) => {
  context.commit("resetPost")
}
